var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("PTOs")]),_vm._v(" "),_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_vm._v("Total: "+_vm._s(_vm.count(_vm.approvedPtos)))]),_vm._v(" "),_c('ptos-list',{attrs:{"ptos":_vm.approvedPtos,"showColumns":_vm.showColumns}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc50c12a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pto/PtosForWeek.vue
// module id = 2wzP
// module chunks = 1